var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.978%",
    y1: "2.779%",
    x2: "51.785%",
    y2: "105.142%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DD0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.995 11.004c.534 0 1.036.208 1.414.586.378.378.586.88.586 1.414V31a1 1 0 0 1-1 1H12.998a1 1 0 1 1 0-2h1v-9.331c0-.44.178-.868.488-1.18a1.66 1.66 0 0 1 1.178-.487h3.332v-5.998c0-.534.208-1.036.586-1.414.378-.378.88-.586 1.414-.586ZM9.329.128a10.997 10.997 0 0 1 12.163 7.577 1 1 0 0 1-1.909.6 9 9 0 0 0-3.827-4.944A8.999 8.999 0 0 0 2 11.003c0 3.2 4.027 11.078 8.018 17.467a1 1 0 0 1-1.697 1.06C6.932 27.306 0 15.957 0 11.004A10.999 10.999 0 0 1 9.329.128Zm20.666 12.876h-9v5.998h2.334c.445 0 .864.174 1.179.488.31.31.488.74.488 1.179v9.33h4.999v-8.997h-2a1 1 0 1 1 0-2h2v-2h-2a1 1 0 1 1 0-2h2v-1.998Zm-7 7.998h-6.997V30h6.998v-5h-3a1 1 0 1 1 0-2h3v-1.998ZM10.999 5.006c1.603 0 3.109.624 4.242 1.757a5.955 5.955 0 0 1 1.757 4.24 5.96 5.96 0 0 1-1.757 4.243 5.959 5.959 0 0 1-4.242 1.757 5.959 5.959 0 0 1-4.242-1.757A5.96 5.96 0 0 1 5 11.004c0-1.603.624-3.11 1.757-4.241a5.959 5.959 0 0 1 4.242-1.757Zm0 2a3.976 3.976 0 0 0-2.828 1.17A3.972 3.972 0 0 0 7 11.004c0 1.068.416 2.073 1.17 2.828a3.976 3.976 0 0 0 2.829 1.17 3.973 3.973 0 0 0 2.828-1.17 3.974 3.974 0 0 0 1.17-2.828 3.972 3.972 0 0 0-1.17-2.827 3.973 3.973 0 0 0-2.828-1.171Z",
    id: "locationLarge-12981927987982"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-locationLarge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "locationLarge-9819792793729",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#locationLarge-12981927987982"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#locationLarge-12981927987982"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-color",
    fill: "url(#linearGradient-3)",
    mask: "url(#locationLarge-9819792793729)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLarge);
export default __webpack_public_path__ + "static/media/locationLarge.88d42dd07d6641775cb3c39a5f75075e.svg";
export { ForwardRef as ReactComponent };